import styled from 'styled-components';

export const CogWrapper = styled.div`
    position: absolute;
    top: 25px;
    right: 35px;
`